import React from 'react';
import { AlertTriangle, X, CheckCircle, Info } from 'lucide-react';

/**
 * Componente para mostrar notificaciones de validación de asientos
 */
const SeatValidationNotification = ({ 
  validationError, 
  recommendations, 
  onClearError, 
  onClearRecommendations, 
  onSelectRecommendedSeat 
}) => {
  if (!validationError && recommendations.length === 0) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-50 space-y-3 max-w-md">
      {/* Error de validación */}
      {validationError && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 shadow-lg">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <AlertTriangle className="h-5 w-5 text-red-400" />
            </div>
            <div className="ml-3 flex-1">
              <h3 className="text-sm font-medium text-red-800">
                Validación de Asientos
              </h3>
              <p className="text-sm text-red-700 mt-1">
                {validationError}
              </p>
            </div>
            <div className="ml-4 flex-shrink-0">
              <button
                onClick={onClearError}
                className="text-red-400 hover:text-red-600"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Recomendaciones */}
      {recommendations.length > 0 && (
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 shadow-lg">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <Info className="h-5 w-5 text-blue-400" />
            </div>
            <div className="ml-3 flex-1">
              <h3 className="text-sm font-medium text-blue-800">
                Asientos Recomendados
              </h3>
              <p className="text-sm text-blue-700 mt-1 mb-3">
                Para evitar asientos individuales vacíos, considera seleccionar:
              </p>
              <div className="space-y-2">
                {recommendations.map((rec, index) => (
                  <div key={index} className="flex items-center justify-between">
                    <span className="text-sm text-blue-700">
                      {rec.seatId}
                    </span>
                    <button
                      onClick={() => onSelectRecommendedSeat(rec.seatId)}
                      className="inline-flex items-center px-2 py-1 text-xs font-medium text-blue-700 bg-blue-100 rounded hover:bg-blue-200 transition-colors"
                    >
                      <CheckCircle className="h-3 w-3 mr-1" />
                      Seleccionar
                    </button>
                  </div>
                ))}
              </div>
            </div>
            <div className="ml-4 flex-shrink-0">
              <button
                onClick={onClearRecommendations}
                className="text-blue-400 hover:text-blue-600"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SeatValidationNotification; 